import React from 'react';

export default function SignupCompleteScreen() {
  return (
    <div>
      <h1>Signup Complete Screen</h1>
    </div>
  );
}